<template>
  <el-badge
    :value="len.length"
    class="item"
    :type="getType"
    v-if="len.length > 0"
  >
  </el-badge>
</template>

<script>
export default {
  name: "pedding-indicator",
  props: {
    tasks: {
      type: Array,
      defult: []
    }
  },

  computed: {
    len: function () {
      return this.tasks.filter((c) => c.PercentageProsposal > 0);
    },
    getType() {
      var pendientes = this.tasks.filter((c) => c.PercentageProsposal > 0);
      // Verficar que alguna de las tareas sean del usuario actual
      // si tiene, colocar rojo, else colorcar de color amarillo

      if (
        pendientes.includes((t) => t.createby == this.currentUser.EmployeeId)
          .length > 0
      ) {
        return "danger";
      } else {
        return "warning";
      }
    }
  }
};
</script>

<style></style>
